var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteTagRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E64D5F",
    fillRule: "evenodd",
    d: "M2.503.478l5.03 5.03 5.03-5.03a1 1 0 011.414 0l.61.61a1 1 0 010 1.415l-5.03 5.03 5.03 5.03a.999.999 0 010 1.414l-.61.61a.999.999 0 01-1.414 0l-5.03-5.03-5.03 5.03a1 1 0 01-1.415 0l-.61-.61a1 1 0 010-1.414l5.03-5.03-5.03-5.03a1.002 1.002 0 010-1.415l.61-.61c.39-.39 1.024-.39 1.415 0z"
  })));
}
export default SvgIconDeleteTagRed;